import { PlusOutlined } from "@ant-design/icons";
import { getTagList } from "@axios/api.account";
import { TagProps } from "@axios/models";
import { getOrgsOptionsSelector, treeNode } from "@redux/selector";
import {
  Breadcrumb,
  Button,
  Col,
  Empty,
  Form,
  FormInstance,
  Input,
  InputNumber,
  Modal,
  Pagination,
  Popconfirm,
  Row,
  Select,
  Space,
  Spin,
  Table,
  notification
} from "antd";
import Column from "antd/lib/table/Column";
import React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import {
  addAsset,
  deleteAsset,
  getAssetById,
  getAssetList
} from "../../axios/api.asset";
import { CancelTokenSource } from "../../axios/axios.core";
import { RootStoreModel } from "../../redux/reducers";
import { gaEvent } from "../../withTracker";
import { BasicStateForListModel } from "../models";

import { Translation } from "react-i18next";

interface stateModel extends BasicStateForListModel {
  isModalVisible: boolean;
  title: string;
  detail: any;
  status: "Active" | "Disabled";
  search: string;
  id: string;
  appTypeVisible: boolean,
  applyPeople: string
  tags: any[],
  selectId: string,
  formSourceType: string
}

interface propsModel extends RouteComponentProps<any, any, any> {
  orgOptions: treeNode[],
}

const mapStatetoProps = (state: RootStoreModel) => ({
  orgOptions: getOrgsOptionsSelector(state),
});

class AssetGroup extends React.Component<propsModel, stateModel> {
  formRef = React.createRef<FormInstance>();
  constructor(props: propsModel) {
    super(props);
    this.state = {
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      loading: false,
      columns: [],
      data: [],
      isModalVisible: false,
      title: "",
      detail: "",
      status: "Active",
      search: "",
      id: "",
      appTypeVisible: false,
      applyPeople: "",
      tags: [],
      selectId: "",
      formSourceType: "Purchase"
    };
  }

  cancelToken = CancelTokenSource();

  componentDidMount() {
    this.getList();
    this.getTasks();
  }

  componentDidUpdate(prevProps: propsModel) { }

  componentWillUnmount() {
    // this.setState = () => { }
    this.cancelToken.cancel("cancel axios http request");
  }
  getTasks = () => {
    getTagList().then((res) => {

      var dat = this.formatOptions(res)
      console.log("formatOptions", dat);
      this.setState({ tags: dat })
    })
  }
  formatOptions = (tags: TagProps[]) => {
    return tags.map(({ id, key, values }) => {
      return {
        value: id,
        label: key,
        children: values.map((item: any) => ({
          value: item.id,
          label: item.value,
        })),
      };
    });
  }
  onSearch = () => {
    this.getList(1);
  };

  getList = (
    pageIndex = this.state.pageIndex,
    pageSize = this.state.pageSize
  ) => {
    const { search } = this.state;
    this.setState({ loading: true });
    getAssetList({ pageIndex, pageSize, search }).then((res) => {
      this.setState({
        data: res.dataList,
        loading: false,
        pageSize: res.pageSize,
        pageIndex: res.pageIndex,
        totalCount: res.totalCount,
      });
    }, () => {
      this.setState({
        loading: false,
      });
    });
  };

  onDelete = (id: string) => {
    this.setState({ loading: true });
    deleteAsset(id).then(() => {
      notification.success({ message: <Translation>{t => {return t("已删除")}}</Translation> });
      this.setState({ loading: false });
      this.getList(1);
    });
  };

  onOk = () => {
    this.formRef.current?.validateFields().then(res => {
      console.log(res)
      this.setState({ loading: true });
      res.id = this.state.id;
      addAsset(res).then(() => {
        notification.success({ message: <Translation>{t => {return t("提交成功")}}</Translation> });
        this.formRef.current?.resetFields();
        this.setState({isModalVisible:false});
        this.getList(1);
      },()=>{
        this.setState({ loading: false});
      });
    })

  };

  onEdit = (item: any) => {
    this.setState({loading:true})
    getAssetById(item.id).then(res=>{
      console.log(res)
      this.setState({isModalVisible:true,loading:false,formSourceType:res.sourceType,id:res.id});
      this.formRef.current?.setFieldsValue(res)
    })
  
   
  };

  onCancel = () => {
    this.setState({isModalVisible:false,id:""});
    this.formRef.current?.resetFields();
  };

  render() {
    const {
      loading,
      data,
      pageSize,
      pageIndex,
      totalCount,
      isModalVisible,
      title,
      search,
      id,
      formSourceType
    } = this.state;
    return (
      (<Translation>{t => {
          return (
            (<div>
              <div className="breadcrumbTop py-2">
                <Breadcrumb>
                  <Breadcrumb.Item>{t("资产")}</Breadcrumb.Item>
                  <Breadcrumb.Item>{t("资产组")}</Breadcrumb.Item>
                </Breadcrumb>
                <Row style={{padding: "32px 0 11px 0"}}>
                    <Space>
                        <img src="/images/assertgroupIcon.svg" alt="" />
                        <span style={{display: "flex", fontSize: 22, fontWeight: 500, marginTop: -8}}>{t("资产组")}</span>
                    </Space>
                </Row>
              </div>
              <Spin spinning={false}>
                <Row style={{ width: "100%" }}>
                  <div className="borderBox">
                    <Row className="mb-3">
                      <Col>
                        {t("资产名称")}:
                        <Input
                          style={{ width: "200px", marginLeft: 10 }}
                          placeholder={t("输入资产名称搜索")}
                          value={search}
                          onChange={(e) => this.setState({ search: e.target.value })}
                        ></Input>
                      </Col>
                      <Col offset={1}>
                        <Button type="primary" onClick={this.onSearch}>
                          {t("查询")}
                        </Button>
                      </Col>

                    </Row>
                  </div>
                  <div className="borderBox">
                    <Row style={{ marginBottom: 8 }}>
                      <Col className="ms-auto">
                        <Button
                          type="primary"
                          onClick={() => { this.setState({ isModalVisible: true }); gaEvent("notification", "onClick", "添加资产") }}
                        >
                          <PlusOutlined />
                          {t("添加资产")}
                        </Button>
                      </Col>
                    </Row>
                    <Table
                      size="middle"
                      loading={loading}
                      dataSource={data}
                      pagination={false}
                      locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                    >
                      <Column
                        key="name"
                        dataIndex="name"
                        title={t("资产名称")}
                      ></Column>
                      <Column
                        key="sourceType"
                        dataIndex="sourceType"
                        title={t("来源")}
                        render={(v: string, d: any) =>
                          {
                          return v=="Purchase"?t("公司购买"):(v=="Lease"?t("租赁"):v)
                        }}
                      ></Column>
                      <Column
                        key="operation"
                        dataIndex="id"
                        title={t("操作")}
                        render={(v: string, d: any) => {
                          return (
                            <Space size={8}>
                              <Button type="link" size="small" onClick={() => { this.onEdit(d); gaEvent("notification", "onClick", "onEdit") }}>
                                {t("编辑")}
                              </Button>
                              <Popconfirm
                                title={`${t("确认删除资产组")} ${d.name}？`}
                                onConfirm={() => this.onDelete(v)}
                                okText={t("确认")}
                                cancelText={t("取消")}
                              >
                                <Button type="link" ghost size="small">
                                  {t("删除")}
                                </Button>
                              </Popconfirm>
                            </Space >
                          );
                        }}
                      ></Column>
                    </Table>
                    <Pagination
                      style={{ textAlign: "right", marginTop: "20px" }}
                      pageSize={pageSize}
                      current={pageIndex}
                      total={totalCount}
                      showTotal={(total, range) =>
                        `${range[0]}-${range[1]} / ${total} ${t("条")}`
                      }
                      onChange={(page, pageSize) => {
                        this.getList(page, pageSize);
                      }}
                      onShowSizeChange={(current, size) => this.getList(current, size)}
                    ></Pagination>
                  </div>
                </Row>
              </Spin>
              <Modal
                maskClosable={false}
                title={id ? t("资产设置") : t("添加资产")}
                confirmLoading={loading}
                open={isModalVisible}
                onOk={() => this.onOk()}
                onCancel={() => this.onCancel()}
                okText={t("确认")}
                cancelText={t("取消")}
              >
                <Form
                  ref={this.formRef}
                  layout="vertical"
                  initialValues={{"sourceType":"Purchase",}}
                >
                  <Form.Item name="name" label={t("资产名称")} rules={[{ required: true }]} >
                    <Input
                      placeholder={t("资产名称")}
                      value={title}
                      onChange={(e) => this.setState({ title: e.target.value })}
                    ></Input>
                  </Form.Item>
                  <Form.Item label={t("来源")} name="sourceType" rules={[{ required: true }]}>
                    <Select defaultValue="Purchase" onChange={e => { this.setState({ formSourceType: e }) }}>
                      <Select.Option value="Purchase">t("公司购买")</Select.Option>
                      <Select.Option value="Lease">t("租赁")</Select.Option>
                      {/* <Select.Option value="LeasePurchase">租赁购买</Select.Option> */}
                    </Select>
                  </Form.Item>

                  {(formSourceType == "Purchase" || formSourceType == "LeasePurchase") && (
                    <>
                      <Row>
                        <Col span={formSourceType == "Purchase" ? 24 : 11}>
                          <Form.Item name={["purchaseDto", "amount"]} label={t("金额")} >
                            <Input type="number"></Input>
                          </Form.Item>
                        </Col>
                        <Col offset={formSourceType == "Purchase" ? 0 : 2} span={formSourceType == "Purchase" ? 24 : 11}>

                          <Form.Item name={["purchaseDto", "depreciationMode"]}  rules={[{ required: true }]} label={t("折旧方式")}>
                            <Select >
                              <Select.Option value="SumOfYears">平均年限法</Select.Option>
                              <Select.Option value="StraightLine">年数总和法</Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={formSourceType == "Purchase" ? 24 : 11}>
                          <Form.Item name={["purchaseDto", "years"]} label={t("折扣年限")}>
                            <Input type="number"></Input>
                          </Form.Item>
                        </Col>
                        <Col offset={formSourceType == "Purchase" ? 0 : 2} span={formSourceType == "Purchase" ? 24 : 11}>
                          <Form.Item name={["purchaseDto", "residualRate"]} label={t("残值率")}>
                            <InputNumber  style={{width:"100%"}} max={1} min={0} type="number"></InputNumber >
                          </Form.Item>
                        </Col>
                      </Row>
                    </>
                  )}

                  {(formSourceType == "Lease" || formSourceType == "LeasePurchase") && (

                    <>
                      <Form.Item name={["leaseDto", "payMethod"]} label={t("支付方式")}>
                          <Select>
                            <Select.Option value="Year">按年</Select.Option>
                            <Select.Option value="Month">按月</Select.Option>
                          </Select>
                      </Form.Item>
                      <Row>
                        <Col span={formSourceType == "Lease" ? 24 : 11}>
                          <Form.Item name={["leaseDto", "amount"]} label={t("分期期数")}>
                            <Input type="number"></Input>
                          </Form.Item>
                        </Col>

                        <Col offset={formSourceType == "Lease" ? 0 : 2} span={formSourceType == "Lease" ? 24 : 11}>
                          <Form.Item name={["leaseDto", "installmentNumber"]} label={t("每期金额")}>
                            <Input type="number"></Input>
                          </Form.Item>
                        </Col>
                      </Row>


                    </>

                  )}
                </Form>
              </Modal>
            </div>)
          );
        }}</Translation>)
    );
  }
}

export default connect(mapStatetoProps, {})(AssetGroup);
